export default __webpack_public_path__ + "static/media/sound_waves_wide_3500w_opacity_25.3633ffca.svg";